var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLanguage = function SvgLanguage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "28px",
    viewBox: "0 0 32 32",
    fill: "#698db0",
    className: "Language__SvgLanguage-jw7cy6-0 kccGWZ",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.407 18.535l1.826 2.283a.521.521 0 11-.814.65l-1.68-2.099-1.68 2.1a.52.52 0 01-.882-.06.523.523 0 01.068-.591l1.826-2.284-.537-.67a.522.522 0 11.815-.653l.39.489 1.002-1.252h-3.61a.522.522 0 010-1.044h2.086v-.522a.522.522 0 011.044 0v.522h2.087a.522.522 0 010 1.044h-.271l-1.67 2.087zM9.141 14.752L8.134 17.17a.522.522 0 11-.964-.401l2.609-6.261a.522.522 0 01.963 0l2.609 6.244a.522.522 0 01-.963.403l-1.003-2.403H9.14zm.435-1.044h1.372l-.686-1.644-.686 1.644zm-4.533 4.827h5.74a.521.521 0 110 1.043H4.522A.52.52 0 014 19.056V8.621a.522.522 0 01.522-.521h13.043a.522.522 0 110 1.043H5.043v9.392zm21.913-5.218h-5.739a.522.522 0 010-1.043h6.261a.522.522 0 01.522.521V23.23a.522.522 0 01-.522.522H14.435a.522.522 0 010-1.044h12.521v-9.39zm-5.13-7.072a.522.522 0 11.869.579L10.173 25.606a.522.522 0 01-.868-.578L21.827 6.245z",
    fill: "#698db0"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLanguage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/language.386e63e9.svg";
export { ForwardRef as ReactComponent };